export default __webpack_public_path__ + "static/media/manufacturing-nfo-banner.78707f17.png";